import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '@/assets/img/end.png';
import _imports_1 from '@/assets/img/unapply.png';
import _imports_2 from '@/assets/img/unstart.png';
import _imports_3 from '@/assets/img/unsign.png';
const _hoisted_1 = {
  key: 0,
  class: "btn-box"
};
const _hoisted_2 = {
  key: 1,
  class: "tabs-container"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 1,
  class: "container-wrapper"
};
const _hoisted_5 = {
  class: "end-box"
};
const _hoisted_6 = {
  class: "end-box-title"
};
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  alt: ""
};
const _hoisted_9 = {
  key: 2,
  src: _imports_2,
  alt: ""
};
const _hoisted_10 = {
  key: 3,
  src: _imports_3,
  alt: ""
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Download = _resolveComponent("Download");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_DocumentChecked = _resolveComponent("DocumentChecked");
  const _component_DocumentRemove = _resolveComponent("DocumentRemove");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", null, [!$data.isEnd ? _withDirectives((_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass({
      'container-wrapper': _ctx.$route.query.scheduleType == 2
    })
  }, [_ctx.$route.query.scheduleType == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.$route.query.scheduleName == '网评材料上传' ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    type: "info",
    plain: "",
    onClick: $options.handleNoticeClick,
    style: {
      "margin-right": "10px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      style: {
        "margin-right": "5px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_Download)]),
      _: 1
    }), _cache[3] || (_cache[3] = _createTextVNode(" 通知附件 "))]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), _ctx.$route.query.scheduleName == '网评材料上传' ? (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    type: "info",
    plain: "",
    onClick: $options.handleDownload,
    style: {
      "margin-right": "10px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      style: {
        "margin-right": "5px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_Download)]),
      _: 1
    }), _cache[4] || (_cache[4] = _createTextVNode(" 下载报名表 "))]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
    type: "info",
    plain: "",
    onClick: $options.submitMaterials,
    disabled: $options.isCanSubmit || $data.isDisabled
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      style: {
        "margin-right": "5px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_DocumentChecked)]),
      _: 1
    }), _cache[5] || (_cache[5] = _createTextVNode(" 提交资料 "))]),
    _: 1
  }, 8, ["onClick", "disabled"])), [[_directive_loading, $data.loading]]), _ctx.$route.query.scheduleName == '汇报材料上传' && _ctx.$route.query.isAudit != 1 ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
    key: 2,
    type: "info",
    plain: "",
    onClick: $options.handleBack
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      style: {
        "margin-right": "5px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_DocumentRemove)]),
      _: 1
    }), _cache[6] || (_cache[6] = _createTextVNode(" 撤回资料 "))]),
    _: 1
  }, 8, ["onClick"])), [[_directive_loading, $data.loadingBack]]) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.$route.query.scheduleType == 2 && _ctx.$route.query.scheduleName == '网评材料上传' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
    class: _normalizeClass(["tabs-item", {
      active: $data.activeTab === 'table'
    }]),
    onClick: _cache[0] || (_cache[0] = $event => $options.onChangeTab('table'))
  }, " 报名表 ", 2), _createElementVNode("div", {
    class: _normalizeClass(["tabs-item", {
      active: $data.activeTab === 'meta'
    }]),
    onClick: _cache[1] || (_cache[1] = $event => $options.onChangeTab('meta'))
  }, " 报名材料 ", 2)])) : _createCommentVNode("", true), _createElementVNode("iframe", {
    onLoad: _cache[2] || (_cache[2] = (...args) => $options.adjustIframeHeight && $options.adjustIframeHeight(...args)),
    ref: "activityIframe",
    class: _normalizeClass({
      'iframe-2': _ctx.$route.query.scheduleName == '网评材料上传',
      iframe: _ctx.$route.query.scheduleName != '网评材料上传'
    }),
    src: $data.iframeUrl,
    frameborder: "0"
  }, null, 42, _hoisted_3)], 2)), [[_directive_loading, $data.isLoading]]) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [$data.n == 2 ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : _createCommentVNode("", true), $data.n == 3 ? (_openBlock(), _createElementBlock("img", _hoisted_8)) : _createCommentVNode("", true), $data.n == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_9)) : _createCommentVNode("", true), $data.n == 4 ? (_openBlock(), _createElementBlock("img", _hoisted_10)) : _createCommentVNode("", true), _createElementVNode("div", null, _toDisplayString($data.n == 1 ? "活动未开始" : $data.n == 2 ? "活动已结束" : $data.n == 3 ? "很遗憾，您未入围现场评审，感谢您的支持！" : $data.n == 4 ? "您未报名参加本次大赛，期待您下次的参与！" : ""), 1)])])]))]);
}